// The link already carries the file name in its content disposition, so following it downloads
// the document and leaves the page where it is.
export function startDownload(url: string) {
  window.location.assign(url)
}
